import Vue from 'vue'
import Vuex from 'vuex';
import axios from 'axios';

Vue.use(Vuex);

export const articleStore = new Vuex.Store({
  state : {

    posts: [],

    category: '',

    currentPage : 1,

    order: 'DESC',

    search_value: '',

    loader: true,

  },

  actions: {
    getPosts ({ commit, state }) {
      axios
        .get('/wp-json/wp/v2/posts/', {
          params: {
            filter_cat: state.category,
            // count : 2,
            s: state.search_value,
            page: state.currentPage,
          }
        })
        .then(response => { return response.data; })
        .then ( posts => {
          commit('SET_POSTS', posts);
          commit('SET_LOADER', false);
        })
    },
  },

  mutations: {
    SET_POSTS (state, posts) {
      state.posts = posts;
    },

    SET_CURR_PAGE (state, currentPage) {
      state.currentPage = currentPage;
    },

    SET_FILTER(state, value) {
      state.category = value;
    },

    SET_SEARCH(state, value) {
      state.search_value = value;
    },

    SET_LOADER(state, value) {
      state.loader = value;
    },
  }
});



// WEBPACK FOOTER //
// ./src/store/article-store.js